"use client";

import { useMutation } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { resetPersonalData } from "../api/resetPersonalData";

export default function useResetPersonalDataMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: () => resetPersonalData(accessToken),
  });
}
